module.exports = __webpack_public_path__ + "img/back04.96bd31a9.jpg";